/**
 * Utility to highlight search terms in text
 */

import { JSX } from "react";

/**
 * Highlight matching text in a string
 * Returns an array of strings and JSX elements with highlighted portions
 * @param text - The text to highlight
 * @param query - The search query
 * @returns Array with text and highlighted portions
 */
export function getHighlightedText(text: string, query: string): (string | JSX.Element)[] {
  if (!query.trim()) {
    return [text];
  }

  // Escape special regex characters in the query
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedQuery})`, 'gi');

  const parts = text.split(regex);

  return parts.map((part, index) => {
    // Check if this part matches the query (case-insensitive)
    if (part.toLowerCase() === query.toLowerCase()) {
      return (
        <mark key={index} className="bg-yellow-300 font-medium">
          {part}
        </mark>
      );
    }
    return part;
  });
}
